<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-50">
      <div class="container">
        <div class="area_wrap">
          <div class="text_wrap info">
            <div class="tw_detail">
              <div class="tw_item">
                <div class="tw_title">
                  <h2>진료시간</h2>
                </div>
                <div class="tw_content other">
                  <span>평일 AM 9:00 ~ PM 5:50</span>
                  <span>토요일 AM 9:00 ~ PM 12:50</span>
                  <span>점심시간 PM 12:50 ~ PM 2:00</span>
                  <span>공휴일 및 일요일 외래 진료가 없습니다.</span>

                  <div class="otherText">
                    <span>수술을 많이 하는 병원이므로, 예약 없이 방문하시면 진료가 불가능할 수 있습니다.</span>
                    <span>내원하시기 전에 전화 문의 및 예약 필수입니다.</span>
                    <span>목 부위 (구강, 인두, 후두, 갑상선, 림프절 등) 검사와 수술에 특화된 이비인후과입니다.</span>
                    <div class="over">
                      <h2>"귀나 코 부위의 수술은 하지 않습니다."</h2>
                      <h2>"단순 감기 약처방은 하지 않습니다."</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tw_item">
                <div class="tw_title">
                  <h2>당일 검사</h2>
                </div>
                <div class="tw_content other">
                  <span>외래 진료 당일에 내시경검사, 초음파검사, 세포 검사 및 조직검사, CT/MRI 검사 등 대부분의 검사를 시행하고,
                    검사 결과도 바로 확인 가능합니다. (세포검사 및 조직검사 결과는 제외)</span>
                  <span>대학병원처럼 검사하는 날을 따로 예약하고, 결과 보기 위해 한번 더 방문하실 필요가 없습니다.</span>
                </div>
              </div>
              <div class="tw_item">
                <div class="tw_title">
                  <h2>당일 시술</h2>
                </div>
                <div class="tw_content">
                  <span>다음과 같은 간단한 외래 시술은 내원 당일에 시행합니다.</span>
                  <div class="bar">
                    <span>갑상선암 및 두경부암 세포검사 및 조직검사</span>
                    <span>침샘 관련 수술: 점액낭종(하마종)의 간단 시술, 침샘관 출구부의 타석증</span>
                    <span>구강 양성 종양 수술: 유두종, 섬유종</span>
                    <span>설소대 수술 (전신마취가 필요한 소아에서는 외래 시술 불가)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '진료시간 안내',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
